import React from 'react';
import ReactDOM from 'react-dom/client';
import { verifySession, redirectToShell, clearSession } from './auth/authBridge';
import App from './App';

(async () => {
  // Check for an existing session via the shared HttpOnly cookie.
  const auth = await verifySession();

  // No session — redirect to the ERP shell to establish one.
  if (!auth) {
    redirectToShell();
    return;
  }

  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <App
        user={{ name: auth.name, email: auth.email }}
        roles={auth.roles}
        refreshToken={async () => {
          // Cookie expired or was revoked — clear it and bounce back to the ERP for a fresh one.
          clearSession();
          redirectToShell();
        }}
      />
    </React.StrictMode>,
  );
})();
